/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
import React from "react";
import {
  useTable,
  Column,
  useSortBy,
  usePagination,
  useGlobalFilter,
  useAsyncDebounce,
} from "react-table";
import { images } from "../../config/images";
import { Input } from "../Input";
import { useAppSelector } from "../../redux/Hooks/Hook";
import { LableFromEnums } from "../../utilities";
import { Button } from "../Button";



const GlobalFilter = ({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}: any) => {
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((val) => {
    setGlobalFilter(val || undefined);
  }, 200);

  return (
    <div className="search-filter">
      <label htmlFor="selectdate" className="form-label me-1">
        Search:{" "}
      </label>
      <Input
        className="form-control form-control-sm"
        type="text"
        name="search-data"
        id="search-data"
        value={value || ""}
        onChange={(e: any) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={`${count} Record . . .`}
      />
    </div>
  );
};

const Table = (props: any) => {
  const { Enums } = useAppSelector((state) => state.enumsArray);
  let EnumArrObj = { ...Enums };
  const {
    columns,
    data,
    handleEdit,
    HandleShow,
    HandleDelete,
    HandleDownload,
    onRowClick = () => {
      //default
    },
    hideEditAction = false,
    hideViewAction = false,
    hideDeleteAction = false,
    hideDownloadAction = true,
    currentPage,
    rowsPerPage,
    totalPage,
    totalRows,
    PreviousPage,
    NextPage,
    show,
    hideGlobalFilter,
    paginationReadOnly = false,
    isSorting = false,
    sorting,
    setSorting,
    orderColComing = [],
    hideActionCol = false
  } = props;
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, globalFilter },
    preGlobalFilteredRows,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const getSortDirection = (column: any) => {
    if (sorting && sorting.column === column.id) {
      return sorting.order === "ASC"
        ? "DESC"
        : sorting.order === "DESC"
          ? ""
          : "ASC";
    }
    return "ASC";
  };

  const handleSort = (column: any) => {
    const newDirection = getSortDirection(column);

    if (newDirection === "") {
      setSorting({ column: "", order: "" });
    } else {
      setSorting({ column: column.id, order: newDirection });
    }
  };

  return (
    <>
      {!show && !hideGlobalFilter && (
        <GlobalFilter
          preGlobalFilteredRows={preGlobalFilteredRows}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
        />
      )}
      <div className="table-responsive">
      <table
        className="react-table text-start table table-bordered table-hover mb-0"
        {...getTableProps()}
      >
        <thead>
          {headerGroups.map((headerGroup: any) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column: any) => (
                <th
                  {...column.getHeaderProps(
                    !isSorting && column.getSortByToggleProps()
                  )}
                >
                  {column.render("Header")}
                  <span
                    style={{ cursor: "pointer" }}
                    className="ms-1 text-light"
                    onClick={() => handleSort(column)}
                  >
                    {/* {isSorting ? orderColComing.includes(column.id)? sorting.order ==='ASC'? "▼" : "▲" : "" :column.isSortedDesc ? "▲" : "▼"} */}
                    {isSorting
                      ? orderColComing.includes(column.id)
                        ? sorting?.column === column.id
                          ? sorting.order === "ASC"
                            ? "▼"
                            : "▲"
                          : "⧎"
                        : ""
                      : column.isSortedDesc
                        ? "▲"
                        : "▼"}
                  </span>
                </th>
              ))}
              {!hideActionCol &&
                <th>Action</th>}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.length === 0 && (
            <tr>
              <td colSpan={columns.length + (hideActionCol ? 0 : 1)} className="text-center text-muted py-3">
                No data found
              </td>
            </tr>
          )}
          {page.map((row: any, i: number) => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                onClick={() => onRowClick(row?.original)}
                style={{ cursor: onRowClick ? "pointer" : "default" }}
              >
                {row.cells.map((cell: any) => {
                  return (
                    <td
                      className={
                        cell.value == "Active"
                          ? "text-success"
                          : cell.value == "Inactive"
                            ? "text-danger"
                            : ""
                      }
                      {...cell.getCellProps()}
                    >
                      {cell.column.Header === "Amount" && (
                        <span className="rupees-symbol">&#8377;</span>
                      )}{" "}
                      {LableFromEnums(cell.value, EnumArrObj)}
                    </td>
                  );
                })}
                <td className="table-icons text-nowrap">
                  {!hideEditAction && (
                    <img
                      className="me-2"
                      src={images.edittable.default}
                      onClick={(e) => {
                        e?.stopPropagation();
                        handleEdit(row.original.id);
                      }}
                      alt="Edit"
                    />
                  )}
                  {!hideViewAction && (
                    <img
                      className="me-2"
                      src={images.viewtable.default}
                      onClick={(e) => {
                        e?.stopPropagation();
                        HandleShow(row.original.id);
                      }}
                      alt="View"
                    />
                  )}
                  {!hideDeleteAction && (
                    <img
                      src={images.deletetable.default}
                      onClick={(e) => {
                        e?.stopPropagation();
                        HandleDelete(row.original.id);
                      }}
                      alt="Delete"
                    />
                  )}
                  {!hideDownloadAction && (
                    <Button
                      type="button"
                      bname="Print Invoice"
                      name="print"
                      id="print"
                      className="btn btn-primary btn-sm rounded-1"
                      onClick={(e: any) => {
                        e?.stopPropagation();
                        HandleDownload(row.original.id);
                      }}
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      </div>
      {!(show || paginationReadOnly) ? (
        <div className="pagination-section d-flex flex-wrap align-items-center justify-content-end gap-3 px-3">
          <div className="text-info d-flex align-items-center gap-1">
            <span className="text-nowrap">Go to page:</span>
            <Input
              className="text-dark form-control form-control-sm"
              type="number"
              name="page-size"
              id="page-size"
              defaultValue={pageIndex + 1}
              onChange={(e: any) => {
                const topage = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(topage);
              }}
              style={{ width: "70px" }}
              onKeyDown={(e: any) => ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()}
            />
          </div>
          <div className="text-info d-flex align-items-center gap-1">
            <span className="text-nowrap">Rows per Page:</span>
            <Input
              className="text-dark form-control form-control-sm"
              type="number"
              name="rows-per-page"
              id="rows-per-page"
              defaultValue={pageSize}
              onChange={(e: any) => {
                const count = (e.target.value != 0 && e.target.value !== "") ? Number(e.target.value) : 1;
                setPageSize(count);
              }}
              style={{ width: "70px" }}
              onKeyDown={(e: any) => ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()}
            />
          </div>
          <div className="pagination-arrow d-flex align-items-center gap-2 text-dark">
            <span className="text-nowrap">Page {pageIndex + 1} of {pageOptions.length}</span>
            <span className="d-flex">
              <input
                type="button"
                className="input-left-arrow"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              />
              <input
                type="button"
                className="input-right-arrow"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              />
            </span>
          </div>
        </div>
      ) : (
        <div className="pagination-section d-flex flex-wrap align-items-center justify-content-end gap-3 px-3">
          <span className="text-info text-nowrap">
            Rows per Page:{" "}
            <span className="text-dark">
              {paginationReadOnly ? pageSize : rowsPerPage}
            </span>
          </span>
          {paginationReadOnly ? (
            <span className="text-info">{`${pageIndex + 1} of ${pageOptions.length}`}</span>
          ) : (
            <span className="text-info">{`${currentPage} - ${totalPage} of ${totalRows}`}</span>
          )}
          <span className="d-flex">
            <input
              type="button"
              className="input-left-arrow"
              disabled={currentPage === 1}
              onClick={
                paginationReadOnly
                  ? () => previousPage()
                  : () => PreviousPage(currentPage - 1)
              }
            />
            <input
              type="button"
              className="input-right-arrow"
              disabled={currentPage >= totalPage}
              onClick={
                paginationReadOnly
                  ? () => nextPage()
                  : () => NextPage(currentPage + 1)
              }
            />
          </span>
        </div>
      )}
    </>
  );
};

export { Table };
